<div fxLayout="column" fxLayoutGap="0" fxFlex>
  <img src="assets/images/ic_courier.svg" alt="Courier pick-up" />
  <h2 mat-dialog-title>Making Your Pickup Run Smoother</h2>
  <div fxLayout="column" fxLayoutGap="0" fxFlex matDialogContent>
    <div fxLayout="column" fxFlex fxLayoutGap="10px">
      <p>
        Would you be able to bring your items to the ground floor before your pickup? This helps ensure a faster and easier experience for
        everyone and could even reduce the cost of your pickup!
      </p>
      <mat-radio-group [(ngModel)]="removeStairs" fxLayout="column" fxLayoutGap="10px">
        <mat-radio-button class="staircases-radio-button" [value]="true">
          <b>Yes, I can bring the items down</b>
          to the ground floor.
        </mat-radio-button>
        <mat-radio-button class="staircases-radio-button" [value]="false">
          No I will
          <b>not</b>
          bring the items down to the ground floor.
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div matDialogActions fxLayout="row" fxLayoutAlign="end" style="padding: 20px">
    <button class="primary-btn filled-btn" (click)="reference.close(removeStairs)">Continue</button>
  </div>
</div>
